import { FC, useState } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip';

const ClipboardCell: FC<React.PropsWithChildren<GridCellProps>> = ({ dataItem, field, colSpan, columnIndex, isSelected, ariaColumnIndex }) => {
  const [open, setOpen] = useState(false);
  const cellValue = String((field && dataItem?.[field]) ?? '');
  const displayValue = cellValue.length > 30 ? `${cellValue.slice(0, 30)}...` : cellValue;

  return (
    <td colSpan={colSpan} role="gridcell" aria-colindex={ariaColumnIndex} aria-selected={isSelected} data-grid-col-index={columnIndex}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>{displayValue}</div>
        <Tooltip title="Copied Item #" placement="top" arrow open={open}>
          <IconButton
            onPointerDown={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              navigator.clipboard.writeText(cellValue);
              setOpen(true);
              setTimeout(() => setOpen(false), 1500);
            }}
            size="small"
          >
            <ContentCopyIcon fontSize="inherit" sx={{ color: '#999' }} />
          </IconButton>
        </Tooltip>
      </div>
    </td>
  );
};

export default ClipboardCell;
